(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-register"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const STORAGE_KEY = 'wd_register_return_url'
    const params = new URLSearchParams(window.location.search)
    const returnTo = params.get('return_to')
    const anchor = params.get('anchor')
    const signInLink = document.querySelector('#signInLink')
    if (returnTo) {
      const returnUrl = returnTo + '?track=wd_register_success' + (anchor ? `&anchor=${anchor}` : '')
      sessionStorage.setItem(STORAGE_KEY, returnUrl)

      if (signInLink) {
        signInLink.href = `${signInLink.href}?${params.toString()}`
      }
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-x-series-speed-showcase"] && !Shopify.designMode) return;
  try {
    
  ;(() => {
    const selectors = {
      root: '.page-x-series-speed-showcase',
      trigger: '[data-speed-showcase-trigger]',
      panel: '[data-speed-showcase-panel]'
    }

    const initSection = section => {
      const triggers = Array.from(section.querySelectorAll(selectors.trigger))
      const panels = Array.from(section.querySelectorAll(selectors.panel))

      if (!triggers.length || !panels.length) return

      const setActive = targetId => {
        triggers.forEach(trigger => {
          const isActive = trigger.dataset.speedShowcaseTarget === targetId
          trigger.classList.toggle('page-x-series-speed-showcase__item--active', isActive)
          trigger.setAttribute('aria-pressed', isActive ? 'true' : 'false')
        })

        panels.forEach(panel => {
          const isActive = panel.dataset.speedShowcasePanel === targetId
          panel.classList.toggle('is-active', isActive)
        })
      }

      triggers.forEach(trigger => {
        trigger.addEventListener('click', () => {
          setActive(trigger.dataset.speedShowcaseTarget)
        })
      })

      const initialTrigger =
        triggers.find(trigger => trigger.classList.contains('page-x-series-speed-showcase__item--active')) ||
        triggers[0]

      if (initialTrigger) {
        setActive(initialTrigger.dataset.speedShowcaseTarget)
      }
    }

    document.querySelectorAll(selectors.root).forEach(initSection)
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prize-draw"] && !Shopify.designMode) return;
  try {
    
  class PrizeDrawSection extends HTMLElement {
    constructor() {
      super()
      // 已揭晓的彩蛋数量（用于切换文案和全部揭晓状态）。
      this.revealedCount = 0
      // 本地存储键：记录已砸开的彩蛋索引。
      this.brokenEggStorageKey = 'WDPRIZEDRAWBROKEN'
      // 缓存监听器引用，组件卸载时用于统一解绑。
      this.eggListeners = []
      // 记录礼花自动清空的定时器，便于在关闭弹窗时取消。
      this.confettiClearTimer = null
      // 预绑定方法，保证 add/removeEventListener 使用同一函数引用。
      this.boundHidePrizeModal = this.hidePrizeModal.bind(this)
      this.boundHandleSectionViewed = this.handleSectionViewed.bind(this)
      this.boundHandleLoginBtnClick = this.handleLoginBtnClick.bind(this)
      this.boundHandleLoginTextClick = this.handleLoginTextClick.bind(this)
    }

    connectedCallback() {
      if (this.initialized) return
      this.initialized = true

      // 缓存运行时需要的节点和状态，避免重复查询 DOM。
      this.isLoggedIn = this.dataset.loggedIn === 'true'
      this.customerId = this.dataset.customerId
      this.customerTier = this.dataset.customerTier
      this.mainEl = this.querySelector('.prize-draw__main')
      this.eggItems = Array.from(this.querySelectorAll('.prize-draw__egg-item'))
      this.initialText = this.querySelector('.prize-draw__text--initial')
      this.revealedText = this.querySelector('.prize-draw__text--revealed')
      this.loginText = this.querySelector('.prize-draw__break-login-text')
      this.prizeModal = document.getElementById('PrizeModal')
      this.confettiImg = this.prizeModal && this.prizeModal.querySelector('.prize-draw__confetti-img')
      this.loginBtn = this.prizeModal && this.prizeModal.querySelector('.prize-draw__btn-login')
      // 去掉防缓存时间戳参数，后续通过重新拼接 `&t=` 来重播礼花 GIF。
      this.confettiBaseSrc = this.confettiImg ? this.confettiImg.src.split('&t=')[0] : ''

      this.restoreBrokenEggs()
      this.bindEggEvents()
      this.bindViewEvent()
      this.bindLoginBtnEvent()
      this.bindLoginTextEvent()
    }

    disconnectedCallback() {
      // 组件销毁时解绑所有彩蛋点击监听，避免内存泄漏。
      this.eggListeners.forEach(function (item) {
        item.egg.removeEventListener('click', item.handler)
      })
      this.eggListeners = []

      if (this.confettiClearTimer) {
        clearTimeout(this.confettiClearTimer)
        this.confettiClearTimer = null
      }

      if (this.viewObserver) {
        this.viewObserver.disconnect()
        this.viewObserver = null
      }

      if (this.loginBtn) {
        this.loginBtn.removeEventListener('click', this.boundHandleLoginBtnClick)
      }

      if (this.loginText) {
        this.loginText.removeEventListener('click', this.boundHandleLoginTextClick)
      }
    }

    bindViewEvent() {
      // 单实例生命周期内只上报一次，重复挂载时也避免重复触发。
      if (this.hasViewedEventSent) return

      if (!('IntersectionObserver' in window)) {
        this.handleSectionViewed()
        return
      }

      this.viewObserver = new IntersectionObserver(this.boundHandleSectionViewed, {
        root: null,
        threshold: 0.5
      })
      this.viewObserver.observe(this)
    }

    handleSectionViewed(entries) {
      if (this.hasViewedEventSent) return

      var isVisible = true
      if (entries && entries.length) {
        isVisible = entries.some(function (entry) {
          return entry.isIntersecting
        })
      }
      if (!isVisible) return

      var payload = {}
      if (this.isLoggedIn && this.customerId) {
        payload.event_action = this.customerId
        payload.event_category = this.customerTier
      }

      // 当彩蛋板块出现在可视区，上报埋点
      if (typeof window.WDSendEvent === 'function') {
        window.WDSendEvent('wd_easter_egg_viewed', payload)
      }

      this.hasViewedEventSent = true
      if (this.viewObserver) {
        this.viewObserver.disconnect()
        this.viewObserver = null
      }
    }

    /* 彩蛋揭晓埋点 */
    trackEggOpened(egg, idx) {
      if (typeof window.WDSendEvent !== 'function') return

      var payload = {
        event_action: this.customerId || '',
        event_category: this.customerTier || '',
        event_label: String(idx + 1),
        value: egg.dataset.prizeAmount
      }

      window.WDSendEvent('wd_easter_egg_opened', payload)
    }

    bindEggEvents() {
      var self = this
      this.eggItems.forEach(function (egg) {
        // 鼠标样式由外层样式统一控制，这里跟随父级继承。
        egg.style.cursor = 'inherit'

        var handler = function () {
          self.handleEggClick(egg)
        }
        self.eggListeners.push({ egg: egg, handler: handler })
        egg.addEventListener('click', handler)
      })
    }

    bindLoginBtnEvent() {
      if (!this.loginBtn) return
      this.loginBtn.addEventListener('click', this.boundHandleLoginBtnClick)
    }

    bindLoginTextEvent() {
      if (!this.loginText) return
      this.loginText.addEventListener('click', this.boundHandleLoginTextClick)
    }

    handleLoginBtnClick(event) {
      var loginUrl = event.currentTarget.getAttribute('href')
      if (!loginUrl) return

      event.preventDefault()

      // 点击登录按钮上报埋点（砸开后的弹窗）
      window.WDSendEvent('wd_login_clicked', {
        event_label: window.location.pathname,
        value: 'easter-egg-break'
      })

      // 略微延迟跳转，给埋点上报留出时间。
      setTimeout(function () {
        window.location.href = loginUrl
      }, 100)
    }

    handleLoginTextClick(event) {
      var loginLink = event.target && event.target.closest && event.target.closest('a')
      if (!loginLink || !this.loginText.contains(loginLink)) return

      var loginUrl = loginLink.getAttribute('href')
      if (!loginUrl) return

      event.preventDefault()

      // 点击登录文本上报埋点
      if (typeof window.WDSendEvent === 'function') {
        window.WDSendEvent('wd_login_clicked', {
          event_label: window.location.pathname,
          value: 'easter-egg'
        })
      }

      // 略微延迟跳转，给埋点上报留出时间。
      setTimeout(function () {
        window.location.href = loginUrl
      }, 100)
    }

    hidePrizeModal() {
      if (this.confettiClearTimer) {
        clearTimeout(this.confettiClearTimer)
        this.confettiClearTimer = null
        this.confettiImg.style.opacity = 1
      }

      if (this.prizeModal && typeof this.prizeModal.hide === 'function') {
        this.prizeModal.hide()
      }
    }

    handleEggClick(egg) {
      // 已揭晓的彩蛋不可重复点击。
      if (egg.classList.contains('prize-draw__egg-item--revealed')) return

      var idx = parseInt(egg.dataset.index, 10)
      var whole = egg.querySelector('.prize-draw__egg-whole')
      // 播放蛋壳抖动动画，再显示弹窗与揭晓结果。
      if (whole) whole.style.animation = 'prize-draw-shake 0.4s ease'

      this.showPrizeModal(idx)

      var self = this
      setTimeout(function () {
        // 与抖动动画时长对齐，动画结束后切换到揭晓态。
        self.revealEgg(egg)
        self.trackEggOpened(egg, idx)
      }, 300)
    }

    getBrokenEggIndices() {
      try {
        var raw = window.localStorage.getItem(this.brokenEggStorageKey)
        if (!raw) return []

        var parsed = JSON.parse(raw)
        if (!Array.isArray(parsed)) return []

        return parsed
          .map(function (item) {
            return parseInt(item, 10)
          })
          .filter(function (idx) {
            return !isNaN(idx)
          })
      } catch (e) {
        return []
      }
    }

    persistBrokenEggIndex(index) {
      if (isNaN(index)) return

      var saved = this.getBrokenEggIndices()
      if (saved.indexOf(index) !== -1) return

      saved.push(index)
      try {
        window.localStorage.setItem(this.brokenEggStorageKey, JSON.stringify(saved))
      } catch (e) {}
    }

    restoreBrokenEggs() {
      var brokenIndices = this.getBrokenEggIndices()
      if (!brokenIndices.length) return

      var self = this
      brokenIndices.forEach(function (idx) {
        var egg = self.eggItems[idx]
        if (!egg) return

        self.revealEgg(egg, true)
      })
    }

    revealEgg(eggEl, isInitial = false) {
      if (!eggEl || eggEl.classList.contains('prize-draw__egg-item--revealed')) return

      var idx = parseInt(eggEl.dataset.index, 10)
      var whole = eggEl.querySelector('.prize-draw__egg-whole')
      var revealed = eggEl.querySelector('.prize-draw__egg-revealed')
      const hasCode = eggEl.dataset.prizeCode !== undefined
      eggEl.classList.add('prize-draw__egg-item--revealed')
      if (whole) whole.classList.add('hidden')
      if (revealed) {
        revealed.classList.remove('hidden')
        if (isInitial) {
          revealed.classList.remove('prize-draw__egg-revealed--animate')
        } else {
          revealed.classList.add('prize-draw__egg-revealed--animate')
        }
      }

      if (!isInitial) {
        this.persistBrokenEggIndex(idx)
      }

      // 每揭晓一个彩蛋，更新一次进度和文案状态。
      this.revealedCount++

      if ((isInitial && this.revealedCount > 1) || hasCode) {
        if (this.initialText) this.initialText.classList.add('hidden')
        if (this.revealedText) this.revealedText.classList.remove('hidden')
      } else {
        if (this.initialText) this.initialText.classList.remove('hidden')
        if (this.revealedText) this.revealedText.classList.add('hidden')
      }

      if (this.mainEl && this.revealedCount >= this.eggItems.length) {
        // 全部彩蛋揭晓后切换容器状态（可用于后续样式/动效）。
        this.mainEl.classList.add('prize-draw__main--revealed')
      }
    }

    showPrizeModal(index) {
      if (!this.prizeModal) return

      var eggItem = this.eggItems[index]

      // 先隐藏所有奖品内容，再仅显示当前彩蛋对应内容。
      this.prizeModal.querySelectorAll('.prize-draw__modal-prize').forEach(function (el) {
        el.classList.add('hidden')
      })

      var target = this.prizeModal.querySelector('[data-prize-index="' + index + '"]')
      var noCode = target.dataset.prizeCode === undefined

      if (this.loginBtn) {
        if (noCode) {
          this.loginBtn.classList.add('hidden')
        } else {
          this.loginBtn.classList.remove('hidden')
        }
      }

      if (target) target.classList.remove('hidden')

      if (this.confettiImg && this.confettiBaseSrc) {
        // 通过清空并重设 src 强制 GIF 重播，制造每次中奖礼花效果。

        if (this.confettiClearTimer) {
          clearTimeout(this.confettiClearTimer)
          this.confettiClearTimer = null
        }
        var self = this
        requestAnimationFrame(function () {
          self.confettiImg.src = self.confettiBaseSrc + '&t=' + Date.now()
          self.confettiImg.style.opacity = 1
        })
        this.confettiClearTimer = setTimeout(function () {
          self.confettiImg.style.opacity = 0
          self.confettiClearTimer = null
        }, 3000)
      }

      if (typeof this.prizeModal.show === 'function') {
        this.prizeModal.show()
      }
    }
  }

  if (!customElements.get('prize-draw-section')) {
    customElements.define('prize-draw-section', PrizeDrawSection)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rewards-check-in"] && !Shopify.designMode) return;
  try {
    
  /* global waterdropAppApi */
  class RewardsCheckIn extends HTMLElement {
    constructor() {
      super()
      this.checkedIn = null
      this.consecutiveDays = null
      this.isSubmitting = false
      this.boundHandleTrackClick = this.handleTrackClick.bind(this)
    }

    get isLoggedIn() {
      return this.hasAttribute('data-logged-in')
    }

    connectedCallback() {
      if (this._initialized) return
      this._initialized = true
      this.addEventListener('click', this.boundHandleTrackClick)
      this.loginModal = document.getElementById('RCI-LoginModal')
      if (!this.isLoggedIn) return
      this.tplNotChecked = this.querySelector('[data-rci-tpl-not-checked]')
      this.tplChecked = this.querySelector('[data-rci-tpl-checked]')
      this.tplLoading = this.querySelector('[data-rci-tpl-loading]')
      this.btn = this.querySelector('[data-check-in-btn]')
      if (!this.btn) return
      this.btn.addEventListener('click', () => this.handleCheckIn())
      if (!this.isLoggedIn) this.setButtonState('not-checked')
    }

    // 在section-rewards-prize-draw.js中调用
    initCheckedIn(checkedIn) {
      this.checkedIn = !!checkedIn
      this.setButtonState(this.checkedIn ? 'checked' : 'not-checked')
    }

    async handleCheckIn() {
      if (this.isSubmitting || this.checkedIn) return
      this.isSubmitting = true
      this.setButtonState('loading')
      try {
        const res = await waterdropAppApi({
          proxy: 'rewards/api',
          endpoint: '/check_in',
          method: 'POST'
        })
        if (res?.code === 200) {
          this.checkedIn = true
          this.setButtonState('checked')
          window.WDSendEvent('wd_checkin_completed', {
            value: 50,
            member_level: this.btn?.dataset.memberLevel || '-',
            event_label: res.data.consecutive_days
          })
          window.showMessage('Super! Ihrem Konto wurden 50 Punkte gutgeschrieben.', 'success')
          // 同步页面所有的积分值
          document.querySelectorAll('[data-points-value]').forEach(el => {
            el.textContent = res.data.points ?? '--'
          })
          document.dispatchEvent(new CustomEvent('points-changed', { detail: { points: res.data.points } }))
        } else {
          window.showMessage(res?.message || 'Check-in fehlgeschlagen. Bitte versuchen Sie es erneut.', 'error')
          this.setButtonState('not-checked')
        }
      } catch (e) {
        console.error('[RewardsCheckIn] check-in error:', e)
        window.showMessage('Check-in fehlgeschlagen. Bitte versuchen Sie es erneut.', 'error')
        this.setButtonState('not-checked')
      } finally {
        this.isSubmitting = false
      }
    }

    handleTrackClick(event) {
      const trigger = event.target.closest('[data-rci-track-click]')
      if (!trigger || !this.contains(trigger) || typeof window.WDSendEvent !== 'function') return

      const params = {}
      const memberLevel = trigger.dataset.memberLevel?.trim()
      if (memberLevel) params.member_level = memberLevel

      window.WDSendEvent('wd_checkin_click', params)
    }

    /**
     * @param {'loading' | 'not-checked' | 'checked'} state
     */
    setButtonState(state) {
      if (!this.btn) return
      this.btn.classList.remove('loading')
      this.btn.removeAttribute('aria-busy')
      switch (state) {
        case 'loading':
          this.btn.disabled = true
          this.btn.innerHTML = ''
          this.btn.classList.add('loading')
          this.btn.setAttribute('aria-busy', 'true')
          if (this.tplLoading) this.btn.appendChild(this.tplLoading.content.cloneNode(true))
          break
        case 'not-checked':
          this.btn.disabled = false
          this.btn.innerHTML = ''
          if (this.tplNotChecked) this.btn.appendChild(this.tplNotChecked.content.cloneNode(true))
          break
        case 'checked':
          this.btn.disabled = true
          this.btn.innerHTML = ''
          if (this.tplChecked) this.btn.appendChild(this.tplChecked.content.cloneNode(true))
          break
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.boundHandleTrackClick)
    }
  }

  customElements.define('rewards-check-in', RewardsCheckIn)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rewards-earn-points"] && !Shopify.designMode) return;
  try {
    
  /**
   * 从 Smile.io API 拉取 earning_rules，渲染为响应式卡片网格，
   * 支持 VIP 等级过滤、按断点控制可见数量、展开/收起。
   */
  class RewardsEarnPoints extends HTMLElement {
    // 各断点下默认显示的卡片数量，超出部分折叠
    static VISIBLE = { desktop: 9, tablet: 8, mobile: 4 }

    // 需要按 VIP 等级拆分的规则名前缀（如 "Place an order - Gold"）
    static TIERED_PREFIXES = ['Geburtstag feiern', 'Bestellung aufgeben']

    // 规则名 → 按钮文案映射，用前缀匹配实现模糊对应
    static NAME_RULES = [
      { name: 'Check In', buttonText: 'Check In' },
      { name: 'Registrieren', buttonText: 'Mitgliedschaft verwalten' },
      { name: 'Newsletter abonnieren', buttonText: 'E-Mail-Einstellungen verwalten' },
      { name: 'SMS abonnieren', buttonText: 'SMS-Einstellungen verwalten' },
      { name: 'Geburtstag feiern', buttonText: 'Geburtstag verwalten' },
      { name: 'Follow on TikTok', buttonText: 'TikTok öffnen' },
      { name: 'Auf Instagram folgen', buttonText: 'Instagram öffnen' },
      { name: 'Share on Facebook', buttonText: 'Facebook öffnen' },
      { name: 'Bestellung aufgeben', buttonText: 'Jetzt einkaufen' }
    ]

    connectedCallback() {
      this.viewTarget = this.closest('.rewards-earn-points.section-container') || this
      this._viewObserver = null
      this._hasViewedEventSent = false
      this.expanded = false
      this.cards = []
      this.grid = this.querySelector('[data-grid]')
      this.cardTpl = this.querySelector('[data-card-tpl]')
      this.moreTpl = this.querySelector('[data-more-tpl]')
      this.moreBtn = null
      this.initViewTracking()
      this.loadData()

      // debounce resize，避免频繁重排
      let timer
      this._onResize = () => {
        clearTimeout(timer)
        timer = setTimeout(() => this.updateVisibility(), 150)
      }
      window.addEventListener('resize', this._onResize)
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this._onResize)
      if (this._viewObserver) {
        this._viewObserver.disconnect()
        this._viewObserver = null
      }
    }

    /** 根据视口宽度返回当前断点标识 */
    get breakpoint() {
      const w = window.innerWidth
      if (w > 1024) return 'desktop'
      if (w > 767) return 'tablet'
      return 'mobile'
    }

    get visibleCount() {
      return RewardsEarnPoints.VISIBLE[this.breakpoint]
    }

    initViewTracking() {
      if (this._hasViewedEventSent || this._viewObserver || !this.viewTarget) return

      if (!('IntersectionObserver' in window)) {
        this.sendViewedEvent()
        return
      }

      this._viewObserver = new IntersectionObserver(
        entries => {
          const hasReachedThreshold = entries.some(
            entry => entry.target === this.viewTarget && entry.isIntersecting && entry.intersectionRatio >= 0.5
          )

          if (!hasReachedThreshold) return
          this.sendViewedEvent()
        },
        { threshold: 0.5 }
      )

      this._viewObserver.observe(this.viewTarget)
    }

    sendViewedEvent() {
      if (this._hasViewedEventSent || typeof window.WDSendEvent !== 'function') return

      window.WDSendEvent('wd_mission_list_viewed', {
        member_level: this.dataset.customerTier || '-'
      })

      this._hasViewedEventSent = true

      if (this._viewObserver) {
        this._viewObserver.disconnect()
        this._viewObserver = null
      }
    }

    async loadData() {
      const res = await waterdropAppApi({ proxy: 'rewards/smile', endpoint: '/earning_rules' })
      this.renderCards(res.earning_rules)
    }

    /** 根据规则名前缀匹配 NAME_RULES，返回展示名和按钮文案；未匹配则回退 'Learn More' */
    resolveRule(name) {
      const lower = name.toLowerCase()
      for (const r of RewardsEarnPoints.NAME_RULES) {
        if (lower.startsWith(r.name.toLowerCase())) return r
      }
      return { name, buttonText: 'Mehr erfahren' }
    }

    /** 格式化积分文案：fixed → "+N Points"，variable → "$M=N Points" */
    formatPoints(rv) {
      if (rv.type === 'fixed') return `+${Math.floor(rv.fixed.value)} Punkte`
      if (rv.type === 'variable')
        return `${Math.floor(rv.variable.per_amount)} €=${Math.floor(rv.variable.value)} Punkte`
      return ''
    }

    /**
     * VIP 等级过滤：对 TIERED_PREFIXES 中的规则只保留与当前用户等级匹配的条目，
     * 非分层规则（如社交关注）全部保留。未登录 / 无等级时原样返回。
     */
     filterByTier(rules) {
      const tier = this.dataset.customerTier
      if (!tier) return rules
      const tierLower = tier.toLowerCase()
      return rules.filter(rule => {
        const nameLower = rule.name.toLowerCase()
        const isTiered = RewardsEarnPoints.TIERED_PREFIXES.some(p => nameLower.startsWith(p.toLowerCase()))
        if (!isTiered) return true
        return nameLower.endsWith(tierLower)
      })
    }

    /** 过滤 → 克隆模板 → 填充数据 → 批量插入 DOM，最后挂载 "更多" 按钮并刷新可见性 */
    renderCards(rules) {
      rules = this.filterByTier(rules)
      this.grid.innerHTML = ''
      this.cards = []

      const frag = document.createDocumentFragment()
      rules.forEach((rule, i) => {
        const { name, buttonText } = this.resolveRule(rule.name)
        // 有等级时显示去掉后缀的通用名，无等级时显示原始名（含等级后缀）
        const displayName = this.dataset.customerTier ? name : rule.name
        const card = this.cardTpl.content.firstElementChild.cloneNode(true)
        card.querySelector('.rep__icon-img').src = rule.image_url
        card.querySelector('.rep__card-title').textContent = displayName
        card.querySelector('.rep__card-points').textContent = this.formatPoints(rule.reward_value)
        const btn = card.querySelector('.rep__card-btn')
        btn.textContent = buttonText
        btn.addEventListener('click', () => {
          SmileUI.openPanel({ deep_link: 'points_activity_rules' })
        })
        this.cards.push(card)
        frag.appendChild(card)
      })
      this.grid.appendChild(frag)

      this.createMoreButton()
      this.updateVisibility()
    }

    /** 从模板克隆 "查看更多" 按钮并插入到网格之后 */
    createMoreButton() {
      const btn = this.moreTpl.content.firstElementChild.cloneNode(true)
      btn.addEventListener('click', () => this.toggle())
      this.moreBtn = btn
      this.grid.after(btn)
    }

    /** 展开/收起所有卡片 */
    toggle() {
      const shouldScrollToButton = this.expanded
      this.expanded = !this.expanded
      this.updateVisibility()

      if (shouldScrollToButton) {
        this.scrollButtonIntoView()
      }
    }

    /** 由于赚取积分规则较多，收起时滚动到“查看更多”按钮位置，提升用户视觉体验 */
    scrollButtonIntoView() {
      if (!this.moreBtn) return

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
      requestAnimationFrame(() => {
        this.moreBtn.scrollIntoView({
          behavior: 'auto',
          block: 'center'
        })
      })
    }

    /** 根据当前断点和展开状态，切换每张卡片及 "更多" 按钮的显示/隐藏 */
    updateVisibility() {
      const limit = this.visibleCount
      const total = this.cards.length
      const count = this.expanded ? total : Math.min(total, limit)

      this.cards.forEach((c, i) => {
        c.style.display = i < count ? '' : 'none'
      })

      if (this.moreBtn) {
        this.moreBtn.style.display = total > limit ? '' : 'none'
        this.moreBtn.textContent = this.expanded ? 'Weniger anzeigen' : 'Mehr anzeigen'
        this.moreBtn.setAttribute('aria-expanded', String(this.expanded))
      }
    }
  }

  customElements.define('rewards-earn-points', RewardsEarnPoints)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rewards-faq"] && !Shopify.designMode) return;
  try {
    
  class RewardsFaq extends HTMLElement {
    static DURATION = 300

    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('details.rewards-faq__item'))
      if (!this.items.length) return

      this.items.forEach(item => {
        item.classList.remove('rewards-faq__item--active')
        item.removeAttribute('open')
        const body = this.getBody(item)
        if (body) body.style.maxHeight = '0px'
      })

      this.classList.add('rewards-faq--initialized')

      this.items.forEach(item => {
        const summary = item.querySelector('summary.rewards-faq__question')
        if (!summary) return
        summary.addEventListener('click', e => {
          e.preventDefault()
          const isOpen = item.classList.contains('rewards-faq__item--active')
          this.closeAll(item)
          if (isOpen) {
            this.closeItem(item)
          } else {
            this.openItem(item)
          }
        })
      })

      this._resizeTimer = null
      this._onResize = () => {
        clearTimeout(this._resizeTimer)
        this._resizeTimer = setTimeout(() => {
          this.items.forEach(item => {
            if (!item.classList.contains('rewards-faq__item--active')) return
            const body = this.getBody(item)
            const inner = this.getInner(item)
            if (body && inner) body.style.maxHeight = inner.scrollHeight + 'px'
          })
        }, 150)
      }
      window.addEventListener('resize', this._onResize)
    }

    disconnectedCallback() {
      if (this._onResize) {
        window.removeEventListener('resize', this._onResize)
        clearTimeout(this._resizeTimer)
      }
    }

    getBody(item) {
      return item.querySelector('.rewards-faq__answer')
    }

    getInner(item) {
      return item.querySelector('.rewards-faq__answer-inner')
    }

    openItem(item) {
      const body = this.getBody(item)
      const inner = this.getInner(item)
      if (!body || !inner) return

      item.setAttribute('open', '')
      item.classList.add('rewards-faq__item--active')
      body.style.maxHeight = '0px'
      requestAnimationFrame(() => {
        body.style.maxHeight = inner.scrollHeight + 'px'
      })
    }

    closeItem(item, cb) {
      const body = this.getBody(item)
      const inner = this.getInner(item)
      if (!body || !inner) return

      body.style.maxHeight = inner.scrollHeight + 'px'
      requestAnimationFrame(() => {
        body.style.maxHeight = '0px'
      })
      item.classList.remove('rewards-faq__item--active')

      setTimeout(() => {
        item.removeAttribute('open')
        if (cb) cb()
      }, RewardsFaq.DURATION)
    }

    closeAll(except) {
      this.items.forEach(it => {
        if (except && it === except) return
        if (it.classList.contains('rewards-faq__item--active') || it.hasAttribute('open')) {
          this.closeItem(it)
        }
      })
    }
  }

  customElements.define('rewards-faq', RewardsFaq)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rewards-points-redeem"] && !Shopify.designMode) return;
  try {
    
  class RewardsPointsRedeem extends HTMLElement {
    static VISIBLE = { desktop: 8, tablet: 6, mobile: 4 }

    connectedCallback() {
      this.expanded = false
      this.cards = []
      this.grid = this.querySelector('[data-grid]')
      this.cardTpl = this.querySelector('[data-card-tpl]')
      this.moreBtn = this.querySelector('[data-more-btn]')
      this.moreBtn?.addEventListener('click', () => this.toggle())
      this.loadData()

      let timer
      this._onResize = () => {
        clearTimeout(timer)
        timer = setTimeout(() => this.updateVisibility(), 150)
      }
      window.addEventListener('resize', this._onResize)
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this._onResize)
    }

    get breakpoint() {
      const w = window.innerWidth
      if (w > 1024) return 'desktop'
      if (w > 767) return 'tablet'
      return 'mobile'
    }

    get visibleCount() {
      return RewardsPointsRedeem.VISIBLE[this.breakpoint]
    }

    async loadData() {
      try {
        const res = await waterdropAppApi({ proxy: 'rewards/smile', endpoint: '/points_products' })
        this.renderCards(res.points_products || [])
      } catch (e) {
        console.warn('[RewardsPointsRedeem] Failed to load:', e)
        this.renderCards([])
      }
    }

    renderCards(products) {
      this.grid.innerHTML = ''
      this.cards = []

      const frag = document.createDocumentFragment()
      products.forEach(product => {
        const card = this.cardTpl.content.firstElementChild.cloneNode(true)

        const imgEl = card.querySelector('.component-image')
        if (imgEl && product.reward?.image_url) {
          imgEl.src = product.reward.image_url
          imgEl.alt = product.reward?.name || ''
          imgEl.removeAttribute('srcset')
          imgEl.removeAttribute('data-srcset')
          imgEl.removeAttribute('sizes')
          imgEl.removeAttribute('data-sizes')
        }

        card.querySelector('[data-name]').textContent = product.reward?.name || ''
        card.querySelector('[data-points]').textContent = `${Number(product.points_price || 0).toLocaleString()} Punkte`

        const btn = card.querySelector('.rpr__card-btn')
        btn.addEventListener('click', () => {
          if (typeof window.SmileUI !== 'undefined' && window.SmileUI.openPanel) {
            window.SmileUI.openPanel({ deep_link: `points_product:${product.id}` })
          }
        })

        this.cards.push(card)
        frag.appendChild(card)
      })
      this.grid.appendChild(frag)
      this.updateVisibility()
    }

    toggle() {
      const shouldScrollToButton = this.expanded
      this.expanded = !this.expanded
      this.updateVisibility()

      if (shouldScrollToButton) {
        this.scrollButtonIntoView()
      }
    }

    /** 由于兑换奖品较多，收起时滚动到“查看更多”按钮位置，提升用户视觉体验 */
    scrollButtonIntoView() {
      if (!this.moreBtn) return

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
      requestAnimationFrame(() => {
        this.moreBtn.scrollIntoView({
          behavior: 'auto',
          block: 'center'
        })
      })
    }

    updateVisibility() {
      const limit = this.visibleCount
      const total = this.cards.length
      const count = this.expanded ? total : Math.min(total, limit)

      this.cards.forEach((c, i) => {
        c.style.display = i < count ? '' : 'none'
      })

      if (this.moreBtn) {
        this.moreBtn.style.display = total > limit ? '' : 'none'
        this.moreBtn.textContent = this.expanded ? 'Weniger anzeigen' : 'Mehr anzeigen'
        this.moreBtn.setAttribute('aria-expanded', String(this.expanded))
      }
    }
  }

  if (!customElements.get('rewards-points-redeem')) {
    customElements.define('rewards-points-redeem', RewardsPointsRedeem)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wd-active-card-draw"] && !Shopify.designMode) return;
  try {
    
  class CardsDrawSection extends HTMLElement {
    constructor() {
      super()
      this.cardListeners = []
      this.rulesListeners = []
      this.boundHandleSectionViewed = this.handleSectionViewed.bind(this)
      this.boundHandleLoginTextClick = this.handleLoginTextClick.bind(this)
    }

    connectedCallback() {
      if (this.initialized) return
      this.initialized = true

      // 缓存板块状态，便于事件处理共用同一组 DOM 引用。
      this.cards = Array.from(this.querySelectorAll('.card-draw__card-item'))
      this.countEl = this.querySelector('[data-flipped-count]')
      this.storageKey = 'WDCARDDRAW'
      this.rulesModalId = this.dataset.rulesModal
      this.revealedCount = 0
      this.isLoggedIn = this.dataset.loggedIn === 'true'
      this.customerId = this.dataset.customerId
      this.customerTier = this.dataset.customerTier
      this.loginText = this.querySelector('.card-draw__login-tip')

      // 先恢复已翻开的卡片，再绑定交互并同步进度。
      this.restoreCards()
      this.bindCardEvents()
      this.bindRulesButtons()
      this.bindGlobalRules()
      this.bindViewEvent()
      this.updateProgress()
      this.bindLoginTextEvent()
    }

    disconnectedCallback() {
      this.cardListeners.forEach(function (item) {
        item.card.removeEventListener('click', item.clickHandler)
        item.card.removeEventListener('keydown', item.keyHandler)
      })
      this.rulesListeners.forEach(function (item) {
        item.button.removeEventListener('click', item.handler, true)
      })
      this.cardListeners = []
      this.rulesListeners = []

      if (this.viewObserver) {
        this.viewObserver.disconnect()
        this.viewObserver = null
      }

      if (this.loginText) {
        this.loginText.removeEventListener('click', this.boundHandleLoginTextClick)
      }
    }

    bindViewEvent() {
      if (this.hasViewedEventSent) return

      if (!('IntersectionObserver' in window)) {
        this.handleSectionViewed()
        return
      }

      this.viewObserver = new IntersectionObserver(this.boundHandleSectionViewed, {
        root: null,
        threshold: 0.5
      })
      this.viewObserver.observe(this)
    }

    bindLoginTextEvent() {
      if (!this.loginText) return
      this.loginText.addEventListener('click', this.boundHandleLoginTextClick)
    }

    handleLoginTextClick(event) {
      var loginLink = event.target && event.target.closest && event.target.closest('a')
      if (!loginLink || !this.loginText.contains(loginLink)) return

      var loginUrl = loginLink.getAttribute('href')
      if (!loginUrl) return

      event.preventDefault()

      // 点击登录文本上报埋点
      if (typeof window.WDSendEvent === 'function') {
        window.WDSendEvent('wd_login_click', {
          event_label: window.location.pathname,
          value: 'card_lottery'
        })
      }

      // 略微延迟跳转，给埋点上报留出时间。
      setTimeout(function () {
        window.location.href = loginUrl
      }, 100)
    }

    handleSectionViewed(entries) {
      if (this.hasViewedEventSent) return

      var isVisible = true
      if (entries && entries.length) {
        isVisible = entries.some(function (entry) {
          return entry.isIntersecting
        })
      }
      if (!isVisible) return

      var payload = {}
      if (this.isLoggedIn && this.customerId) {
        payload.event_action = this.customerId
        payload.event_category = this.customerTier
      }

      if (typeof window.WDSendEvent === 'function') {
        window.WDSendEvent('wd_card_lottery_viewed', payload)
      }

      this.hasViewedEventSent = true
      if (this.viewObserver) {
        this.viewObserver.disconnect()
        this.viewObserver = null
      }
    }

    trackCardResult(item) {
      if (typeof window.WDSendEvent !== 'function') return

      var cardIndex = parseInt(item.dataset.cardIndex, 10)
      var payload = {
        event_label: cardIndex + 1,
        value: item.dataset.prizeAmount
      }

      if (this.isLoggedIn && this.customerId) {
        payload.event_action = this.customerId
        payload.event_category = this.customerTier
      }

      window.WDSendEvent('wd_card_lottery_result', payload)
    }

    bindCardEvents() {
      var self = this
      this.cards.forEach(function (item) {
        var card = item.querySelector('.card-draw__card')
        if (!card) return

        var clickHandler = function (event) {
          // 避免点击优惠券按钮、规则入口等内部控件时触发翻牌。
          if (event.target.closest('button, a, modal-opener')) return
          self.revealCard(item)
        }
        var keyHandler = function (event) {
          if (event.key !== 'Enter' && event.key !== ' ') return
          event.preventDefault()
          self.revealCard(item)
        }

        card.addEventListener('click', clickHandler)
        card.addEventListener('keydown', keyHandler)
        self.cardListeners.push({ card: card, clickHandler: clickHandler, keyHandler: keyHandler })
      })
    }

    bindRulesButtons() {
      var self = this
      this.querySelectorAll('[data-card-rules]').forEach(function (button) {
        var handler = function () {
          self.setRulesContent(button.dataset.cardRules)
        }
        button.addEventListener('click', handler, true)
        self.rulesListeners.push({ button: button, handler: handler })
      })
    }

    bindGlobalRules() {
      var self = this
      this.querySelectorAll('[data-global-rules]').forEach(function (button) {
        var handler = function () {
          self.setRulesContent('global')
        }
        button.addEventListener('click', handler, true)
        self.rulesListeners.push({ button: button, handler: handler })
      })
    }

    setRulesContent(index) {
      if (!this.rulesModalId) return
      var modal = document.getElementById(this.rulesModalId)
      if (!modal) return

      var targetIndex = index || 'global'
      var hasTarget = false
      modal.querySelectorAll('[data-rules-content]').forEach(function (content) {
        var isTarget = content.dataset.rulesContent === String(targetIndex)
        content.classList.toggle('hidden', !isTarget)
        if (isTarget) hasTarget = true
      })

      // 当前卡片没有独立规则时，回退展示全局规则。
      if (!hasTarget && targetIndex !== 'global') {
        this.setRulesContent('global')
      }
    }

    openRulesModal(index) {
      if (!this.rulesModalId) return
      this.setRulesContent(index)
      var modal = document.getElementById(this.rulesModalId)
      if (modal && typeof modal.show === 'function') {
        modal.show()
      }
    }

    revealCard(item, restored) {
      if (!item || item.classList.contains('is-flipped')) return

      // 解锁卡片时，同时更新视觉状态和无障碍文案。
      if (restored) {
        item.classList.add('is-restored')
      }
      item.classList.add('is-flipped')
      var card = item.querySelector('.card-draw__card')
      var label = item.querySelector('[data-card-label]')

      if (card) {
        card.setAttribute('aria-pressed', 'true')
        card.setAttribute('aria-label', 'Entsperrt')
      }
      if (label) {
        label.textContent = 'Entsperrt'
      }

      this.revealedCount += 1
      this.updateProgress()

      if (restored) {
        var inner = item.querySelector('.card-draw__card-inner')
        if (inner) {
          inner.getBoundingClientRect()
        }
        item.classList.remove('is-restored')
      }

      if (!restored) {
        // 只持久化用户本次触发的翻牌，恢复状态不重复写入。
        this.persistCardIndex(item.dataset.cardIndex)
        this.trackCardResult(item)
      }
    }

    updateProgress() {
      if (this.countEl) {
        this.countEl.textContent = String(this.revealedCount)
      }
    }

    getStoredIndices() {
      // localStorage 不可用或数据异常时，按空翻牌记录处理。
      try {
        var raw = window.localStorage.getItem(this.storageKey)
        if (!raw) return []
        var parsed = JSON.parse(raw)
        return Array.isArray(parsed) ? parsed : []
      } catch (error) {
        return []
      }
    }

    persistCardIndex(index) {
      if (index === undefined) return
      var saved = this.getStoredIndices()
      if (saved.indexOf(index) !== -1) return
      saved.push(index)

      try {
        window.localStorage.setItem(this.storageKey, JSON.stringify(saved))
      } catch (error) {}
    }

    restoreCards() {
      var saved = this.getStoredIndices()
      if (!saved.length) return

      // 根据已保存的卡片索引恢复刷新前的解锁状态。
      var self = this
      saved.forEach(function (index) {
        var card = self.cards.find(function (item) {
          return item.dataset.cardIndex === String(index)
        })
        self.revealCard(card, true)
      })
    }
  }

  if (!customElements.get('cards-draw-section')) {
    customElements.define('cards-draw-section', CardsDrawSection)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wd-vis-active-halloween"] && !Shopify.designMode) return;
  try {
    
  class HalloweenDraw extends HTMLElement {
    constructor() {
      super()
      this.revealedCount = 0
      this.isBusy = false
      this.prizeListeners = []
      this.confettiClearTimer = null
      this.boundHidePrizeModal = this.hidePrizeModal.bind(this)
      this.boundHandleSectionViewed = this.handleSectionViewed.bind(this)
      this.boundHandleLoginBtnClick = this.handleLoginBtnClick.bind(this)
      this.boundHandleLoginTextClick = this.handleLoginTextClick.bind(this)
    }

    connectedCallback() {
      if (this.initialized) return
      this.initialized = true

      this.isLoggedIn = this.dataset.loggedIn === 'true'
      this.customerId = this.dataset.customerId
      this.customerTier = this.dataset.customerTier
      this.clickMode = this.dataset.clickMode || 'once'
      this.showModal = this.dataset.showModal === 'true'
      this.storageKey = this.dataset.storageKey
      this.prizeModal = document.getElementById(this.dataset.prizeModal)
      this.confettiImg = this.prizeModal && this.prizeModal.querySelector('.prize-draw__confetti-img')
      this.confettiBaseSrc = this.confettiImg ? this.confettiImg.src.split('&t=')[0] : ''
      this.prizeItems = Array.from(this.querySelectorAll('.wd-halloween__prize'))
      this.drawBtns = Array.from(this.querySelectorAll('.wd-halloween__btn'))
      this.drawBtn = this.drawBtns[0] || null
      this.initialCopy = this.querySelector('.wd-halloween__copy--initial')
      this.revealedCopy = this.querySelector('.wd-halloween__copy--revealed')
      this.loginText = this.querySelector('.prize-draw__break-login-text')
      this.loginBtn = this.prizeModal && this.prizeModal.querySelector('.prize-draw__btn-login')

      this.restoreRevealed()
      this.bindButton()
      this.bindViewEvent()
      this.bindLoginBtnEvent()
      this.bindLoginTextEvent()
      this.bindModalScrollLock()
    }

    disconnectedCallback() {
      if (this.drawBtns) {
        this.drawBtns.forEach(btn => btn.removeEventListener('click', this.boundDrawClick))
      }
      if (this.confettiClearTimer) {
        clearTimeout(this.confettiClearTimer)
        this.confettiClearTimer = null
      }
      if (this.viewObserver) {
        this.viewObserver.disconnect()
        this.viewObserver = null
      }
      if (this.loginBtn) {
        this.loginBtn.removeEventListener('click', this.boundHandleLoginBtnClick)
      }
      if (this.loginText) {
        this.loginText.removeEventListener('click', this.boundHandleLoginTextClick)
      }
      this.unbindModalScrollLock()
      this.syncModalScrollLock()
    }

    bindButton() {
      this.drawBtns = Array.from(this.querySelectorAll('.wd-halloween__btn'))
      this.drawBtn = this.drawBtns[0] || null
      if (!this.drawBtns.length) return
      this.boundDrawClick = this.handleDrawClick.bind(this)
      this.drawBtns.forEach(btn => btn.addEventListener('click', this.boundDrawClick))
    }

    bindViewEvent() {
      if (this.hasViewedEventSent) return
      if (!('IntersectionObserver' in window)) {
        this.handleSectionViewed()
        return
      }
      this.viewObserver = new IntersectionObserver(this.boundHandleSectionViewed, {
        root: null,
        threshold: 0.5
      })
      this.viewObserver.observe(this)
    }

    handleSectionViewed(entries) {
      if (this.hasViewedEventSent) return
      let isVisible = true
      if (entries && entries.length) {
        isVisible = entries.some(entry => entry.isIntersecting)
      }
      if (!isVisible) return

      const payload = {}
      if (this.isLoggedIn && this.customerId) {
        payload.event_action = this.customerId
        payload.event_category = this.customerTier
      }
      if (typeof window.WDSendEvent === 'function') {
        window.WDSendEvent('wd_easter_egg_viewed', payload)
      }
      this.hasViewedEventSent = true
      if (this.viewObserver) {
        this.viewObserver.disconnect()
        this.viewObserver = null
      }
    }

    trackPrizeOpened(prize, idx) {
      if (typeof window.WDSendEvent !== 'function') return
      const prizeCode = prize.getAttribute('data-prize-code')
      const prizeAmount = prizeCode ? prize.getAttribute('data-prize-amount') || '' : ''
      window.WDSendEvent('wd_easter_egg_opened', {
        event_action: this.customerId || '',
        event_category: this.customerTier || '',
        event_label: String(idx + 1),
        value: prizeAmount
      })
    }

    bindLoginBtnEvent() {
      if (!this.loginBtn) return
      this.loginBtn.addEventListener('click', this.boundHandleLoginBtnClick)
    }

    bindLoginTextEvent() {
      if (!this.loginText) return
      this.loginText.addEventListener('click', this.boundHandleLoginTextClick)
    }

    bindModalScrollLock() {
      this.rulesModal = document.getElementById(this.dataset.rulesModal)
      this.scrollLockModals = [this.prizeModal, this.rulesModal].filter(Boolean)
      this.boundModalScrollLock = this.syncModalScrollLock.bind(this)
      this.boundModalTouchMove = this.handleModalTouchMove.bind(this)
      this.boundModalWheel = this.handleModalWheel.bind(this)
      this.scrollLockModals.forEach(modal => {
        modal.addEventListener('modal:show', this.boundModalScrollLock)
        modal.addEventListener('modal:hide', this.boundModalScrollLock)
        modal.addEventListener('touchmove', this.boundModalTouchMove, { passive: false })
        modal.addEventListener('wheel', this.boundModalWheel, { passive: false })
      })
    }

    unbindModalScrollLock() {
      if (!this.scrollLockModals) return
      this.scrollLockModals.forEach(modal => {
        modal.removeEventListener('modal:show', this.boundModalScrollLock)
        modal.removeEventListener('modal:hide', this.boundModalScrollLock)
        modal.removeEventListener('touchmove', this.boundModalTouchMove)
        modal.removeEventListener('wheel', this.boundModalWheel)
      })
    }

    syncModalScrollLock() {
      const modalOpen = document.querySelector('modal-container.wd-halloween-modal[open]')
      if (modalOpen) {
        this.lockPageScroll()
        return
      }
      this.unlockPageScroll()
    }

    lockPageScroll() {
      if (HalloweenDraw.pageScrollLocked) return
      HalloweenDraw.pageScrollLocked = true
      document.documentElement.classList.add('wd-halloween-scroll-lock')
      document.body.classList.add('wd-halloween-scroll-lock')
    }

    unlockPageScroll() {
      if (!HalloweenDraw.pageScrollLocked) return
      HalloweenDraw.pageScrollLocked = false
      document.documentElement.classList.remove('wd-halloween-scroll-lock')
      document.body.classList.remove('wd-halloween-scroll-lock')
    }

    handleModalTouchMove(event) {
      const modal = event.currentTarget
      if (!modal || !modal.hasAttribute('open')) return
      const content = event.target.closest && event.target.closest('.modal-content')
      if (content && content.scrollHeight > content.clientHeight + 1) return
      event.preventDefault()
    }

    handleModalWheel(event) {
      const modal = event.currentTarget
      if (!modal || !modal.hasAttribute('open')) return
      const content = event.target.closest && event.target.closest('.modal-content')
      if (content && content.scrollHeight > content.clientHeight + 1) return
      event.preventDefault()
    }

    handleLoginBtnClick(event) {
      const loginUrl = event.currentTarget.getAttribute('href')
      if (!loginUrl) return
      event.preventDefault()
      window.WDSendEvent('wd_login_clicked', {
        event_label: window.location.pathname,
        value: 'easter-egg-break'
      })
      setTimeout(() => {
        window.location.href = loginUrl
      }, 100)
    }

    handleLoginTextClick(event) {
      const loginLink = event.target && event.target.closest && event.target.closest('a')
      if (!loginLink || !this.loginText.contains(loginLink)) return
      const loginUrl = loginLink.getAttribute('href')
      if (!loginUrl) return
      event.preventDefault()
      if (typeof window.WDSendEvent === 'function') {
        window.WDSendEvent('wd_login_clicked', {
          event_label: window.location.pathname,
          value: 'easter-egg'
        })
      }
      setTimeout(() => {
        window.location.href = loginUrl
      }, 100)
    }

    hidePrizeModal() {
      if (this.confettiClearTimer) {
        clearTimeout(this.confettiClearTimer)
        this.confettiClearTimer = null
        if (this.confettiImg) this.confettiImg.style.opacity = 1
      }
      if (this.prizeModal && typeof this.prizeModal.hide === 'function') {
        this.prizeModal.hide()
      }
    }

    handleDrawClick(event) {
      const btn = event && event.currentTarget ? event.currentTarget : this.drawBtn
      if (!btn || btn.disabled) return
      if (this.clickMode !== 'multiple' && this.isBusy) return

      if (this.clickMode === 'multiple') {
        const idx = parseInt(btn.dataset.index, 10)
        const prize = this.prizeItems[idx]
        if (!prize || prize.classList.contains('is-revealed') || prize.classList.contains('is-animating')) return
        this.disableButton(idx)
        const pending = this.prizeItems.filter(item => {
          return item !== prize && !item.classList.contains('is-revealed') && !item.classList.contains('is-animating')
        })
        if (!pending.length) this.setFinished()
        if (this.showModal) this.showPrizeModal(idx)
        this.revealPrize(prize, false)
        return
      }

      const pending = this.prizeItems.filter(item => {
        return !item.classList.contains('is-revealed') && !item.classList.contains('is-animating')
      })
      if (!pending.length) {
        this.setFinished()
        return
      }

      this.setFinished()
      pending.forEach(item => this.revealPrize(item, false))
    }

    getRevealedIndices() {
      try {
        const raw = window.localStorage.getItem(this.storageKey)
        if (!raw) return []
        const parsed = JSON.parse(raw)
        if (!Array.isArray(parsed)) return []
        return parsed.map(item => parseInt(item, 10)).filter(idx => !isNaN(idx))
      } catch (e) {
        return []
      }
    }

    persistRevealedIndex(index) {
      if (isNaN(index)) return
      const saved = this.getRevealedIndices()
      if (saved.indexOf(index) !== -1) return
      saved.push(index)
      try {
        window.localStorage.setItem(this.storageKey, JSON.stringify(saved))
      } catch (e) {}
    }

    restoreRevealed() {
      const saved = this.getRevealedIndices()
      saved.forEach(idx => {
        const prize = this.prizeItems[idx]
        if (!prize) return
        this.revealPrize(prize, true)
        this.disableButton(idx)
      })
      const pending = this.prizeItems.filter(item => !item.classList.contains('is-revealed'))
      if (this.prizeItems.length && !pending.length) this.setFinished()
    }

    revealPrize(prizeEl, isInitial) {
      if (!prizeEl || prizeEl.classList.contains('is-revealed') || prizeEl.classList.contains('is-animating')) return
      const idx = parseInt(prizeEl.dataset.index, 10)
      const prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches

      if (isInitial || prefersReduced) {
        prizeEl.classList.add('is-revealed')
        if (!isInitial) {
          this.persistRevealedIndex(idx)
          this.trackPrizeOpened(prizeEl, idx)
          this.isBusy = false
        }
        this.updateCopyState()
        return
      }

      prizeEl.classList.add('is-animating')
      const before = prizeEl.querySelector('.wd-halloween__before')
      let finished = false
      const complete = () => {
        if (finished) return
        finished = true
        prizeEl.classList.remove('is-animating')
        prizeEl.classList.add('is-revealed')
        this.isBusy = false
        this.updateCopyState()
      }
      if (before) before.addEventListener('animationend', complete, { once: true })
      setTimeout(complete, 900)
      this.persistRevealedIndex(idx)
      this.trackPrizeOpened(prizeEl, idx)
    }

    updateCopyState() {
      const revealedItems = this.prizeItems.filter(item => {
        return item.classList.contains('is-revealed') || item.classList.contains('is-animating')
      })
      let showRevealedCopy = revealedItems.length > 0
      if (this.clickMode === 'multiple') {
        showRevealedCopy = revealedItems.some(item => item.dataset.prizeCode)
      }
      if (this.initialCopy) this.initialCopy.classList.toggle('hidden', showRevealedCopy)
      if (this.revealedCopy) this.revealedCopy.classList.toggle('hidden', !showRevealedCopy)
    }

    disableButton(idx) {
      if (this.clickMode !== 'multiple' || !this.drawBtns) return
      const btn = this.drawBtns.find(item => parseInt(item.dataset.index, 10) === idx)
      if (!btn) return
      btn.disabled = true
      btn.classList.add('is-disabled')
    }

    setFinished() {
      const buttons = this.drawBtns && this.drawBtns.length ? this.drawBtns : []
      buttons.forEach(btn => {
        btn.disabled = true
        btn.classList.add('is-disabled')
      })
    }

    showPrizeModal(index) {
      if (!this.prizeModal) return
      this.prizeModal.querySelectorAll('.prize-draw__modal-prize').forEach(el => {
        el.classList.add('hidden')
      })
      const target = this.prizeModal.querySelector('[data-prize-index="' + index + '"]')
      const noCode = !target || target.dataset.prizeCode === undefined
      const loginBtn = this.prizeModal.querySelector('.prize-draw__btn-login')
      if (loginBtn) loginBtn.classList.toggle('hidden', noCode)
      if (target) target.classList.remove('hidden')

      if (this.confettiImg && this.confettiBaseSrc) {
        if (this.confettiClearTimer) {
          clearTimeout(this.confettiClearTimer)
          this.confettiClearTimer = null
        }
        requestAnimationFrame(() => {
          this.confettiImg.src = this.confettiBaseSrc + '&t=' + Date.now()
          this.confettiImg.style.opacity = 1
        })
        this.confettiClearTimer = setTimeout(() => {
          this.confettiImg.style.opacity = 0
          this.confettiClearTimer = null
        }, 3000)
      }

      if (typeof this.prizeModal.show === 'function') this.prizeModal.show()
    }
  }

  if (!customElements.get('halloween-draw')) {
    customElements.define('halloween-draw', HalloweenDraw)
  }

  ;(() => {
    if (window.__wdHalloweenAutoApply) return
    window.__wdHalloweenAutoApply = true

    const AUTO_APPLY_DISCOUNT_KEY = 'wd-auto-apply-discount-codes'
    const AUTO_APPLY_DISCOUNT_PENDING_KEY = 'wd-auto-apply-discount-pending'
    let halloweenDiscountQueue = Promise.resolve()
    let autoDiscountApplying = false

    function setAutoDiscountButtonsBusy(busy) {
      autoDiscountApplying = busy
      document.querySelectorAll('.wd-halloween [data-auto-apply="true"], .wd-halloween-modal [data-auto-apply="true"]').forEach(button => {
        button.disabled = busy
      })
    }

    function readAutoApplyDiscountCodes() {
      try {
        const value = JSON.parse(sessionStorage.getItem(AUTO_APPLY_DISCOUNT_KEY) || '[]')
        return uniqueDiscountCodes(Array.isArray(value) ? value : [])
      } catch {
        return []
      }
    }

    function rememberAutoApplyDiscountCode(code) {
      const codes = uniqueDiscountCodes([...readAutoApplyDiscountCodes(), code])
      try {
        sessionStorage.setItem(AUTO_APPLY_DISCOUNT_KEY, JSON.stringify(codes))
      } catch (error) {
        console.error(error)
      }
      return codes
    }

    function isDiscountApplied(cart, code) {
      const codeKey = String(code || '')
        .trim()
        .toUpperCase()
      return (cart?.discount_codes || []).some(
        item =>
          String(item?.code || '')
            .trim()
            .toUpperCase() === codeKey && item.applicable !== false
      )
    }

    async function writeAndRecalculateDiscount(codes) {
      const written = await writeCartDiscount(uniqueDiscountCodes(codes).join(','))
      if (!written) return null
      return (await recalculateCartDiscount(written)) || written
    }

    async function selectBestAutoDiscount(incomingCode) {
      const copied = incomingCode ? rememberAutoApplyDiscountCode(incomingCode) : readAutoApplyDiscountCodes()
      const cart = await fetchDiscountCart()
      if (!cart || !copied.length) return null

      const copiedKeys = new Set(copied.map(code => code.toUpperCase()))
      const others = applicableDiscountCodes(cart).filter(code => !copiedKeys.has(code.toUpperCase()))

      if (!cart.items?.length) {
        try {
          if (copied.length > 1) sessionStorage.setItem(AUTO_APPLY_DISCOUNT_PENDING_KEY, '1')
        } catch (error) {
          console.error(error)
        }
        return writeAndRecalculateDiscount([...others, ...copied])
      }

      try {
        sessionStorage.removeItem(AUTO_APPLY_DISCOUNT_PENDING_KEY)
      } catch (error) {
        console.error(error)
      }

      const stackedCodes = uniqueDiscountCodes([...others, ...copied])
      const stacked = await writeCartDiscount(stackedCodes.join(','))
      if (!stacked) return null

      let chosen = stacked
      if (copied.length >= 2 && !copied.every(code => isDiscountApplied(stacked, code))) {
        const rejected = copied.filter(code => !isDiscountApplied(stacked, code))
        const challengers = []
        if (incomingCode) {
          const incomingKey = String(incomingCode).trim().toUpperCase()
          const incoming = rejected.find(code => code.toUpperCase() === incomingKey)
          if (incoming) challengers.push(incoming)
        }
        for (let index = rejected.length - 1; index >= 0 && challengers.length < 2; index -= 1) {
          const code = rejected[index]
          if (challengers.some(item => item.toUpperCase() === code.toUpperCase())) continue
          challengers.push(code)
        }

        const stackedId = stackedCodes.map(code => code.toUpperCase()).join('|')
        const stackedPrice = Number(stacked.total_price)
        let best = Number.isFinite(stackedPrice)
          ? { price: stackedPrice, id: stackedId, cart: stacked, codes: stackedCodes }
          : null
        let lastId = stackedId
        for (const candidate of challengers) {
          const codes = uniqueDiscountCodes([...others, candidate])
          const id = codes.map(item => item.toUpperCase()).join('|')
          const trial = await writeCartDiscount(codes.join(','))
          lastId = id
          if (!trial || !isDiscountApplied(trial, candidate)) continue
          const price = Number(trial.total_price)
          if (!Number.isFinite(price)) continue
          if (!best || price < best.price) best = { price, id, cart: trial, codes }
        }
        if (!best) {
          chosen = (await writeCartDiscount(stackedCodes.join(','))) || stacked
        } else if (best.id === lastId) {
          chosen = best.cart
        } else {
          chosen = (await writeCartDiscount(best.codes.join(','))) || best.cart
        }
      }

      return (await recalculateCartDiscount(chosen)) || chosen
    }

    function applyCopiedDiscountCode(code) {
      halloweenDiscountQueue = halloweenDiscountQueue
        .catch(() => {})
        .then(async () => {
          try {
            const updated = await selectBestAutoDiscount(code)
            if (!updated) return
            renderCartDiscountSections(updated)
          } finally {
            setAutoDiscountButtonsBusy(false)
          }
        })
    }

    function installHalloweenAutoApply() {
      const previousRemove = window.removeInapplicableDiscountCodes
      window.removeInapplicableDiscountCodes = function removeInapplicableDiscountCodes() {
        halloweenDiscountQueue = halloweenDiscountQueue
          .catch(() => {})
          .then(async () => {
            let pending = false
            try {
              pending = sessionStorage.getItem(AUTO_APPLY_DISCOUNT_PENDING_KEY) === '1'
            } catch (error) {
              console.error(error)
            }
            if (pending && readAutoApplyDiscountCodes().length > 1) {
              const current = await fetchDiscountCart()
              if (current?.items?.length) {
                const updated = await selectBestAutoDiscount()
                if (updated) {
                  renderCartDiscountSections(updated)
                  return
                }
              }
            }
            if (typeof previousRemove === 'function') await previousRemove()
          })
        return halloweenDiscountQueue
      }

      document.addEventListener('click', event => {
        const button = event.target.closest('.wd-halloween-copy-code')
        if (!button || !button.closest('.wd-halloween, .wd-halloween-modal')) return
        const discountCode = button.dataset.value
        if (!discountCode) return

        if (button.dataset.autoApply !== 'true') {
          copyTextProductCard(discountCode)
          button.classList.add('component-code-button--copied')
          window.setTimeout(() => {
            button.classList.remove('component-code-button--copied')
          }, 2000)
          return
        }

        if (autoDiscountApplying) return
        setAutoDiscountButtonsBusy(true)
        applyCopiedDiscountCode(discountCode)
      })
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', installHalloweenAutoApply)
    } else {
      installHalloweenAutoApply()
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wd-vis-active-timeline"] && !Shopify.designMode) return;
  try {
    
  class WdVisTimelineScroll extends HTMLElement {
    connectedCallback() {
      this.alignFrame = requestAnimationFrame(() => this.alignCurrent())
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.alignFrame)
    }

    alignCurrent() {
      if (this.scrollWidth <= this.clientWidth + 1) return
      const current = this.querySelector('[data-timeline-current]')
      if (!current) return
      const left =
        current.getBoundingClientRect().left -
        this.getBoundingClientRect().left +
        this.scrollLeft -
        (this.clientWidth - current.clientWidth) / 2
      this.scrollTo({ left: Math.max(0, left) })
    }
  }

  class WdVisTimelineRecords extends HTMLElement {
    connectedCallback() {
      this.listenerAbort?.abort()
      this.listenerAbort = new AbortController()
      const { signal } = this.listenerAbort
      this.addEventListener('click', this.onClick, { signal })
      this.addEventListener('keydown', this.onKeydown, { signal })
      this.closest('modal-container')?.addEventListener('modal:show', this.onModalShow, { signal })
    }

    disconnectedCallback() {
      this.listenerAbort?.abort()
    }

    // 每次打开都回到排序最后的有中奖邮箱的日期，不保留上次手动切换。
    onModalShow = () => {
      this.activateTab(this.defaultTab())
    }

    defaultTab() {
      const winners = this.querySelectorAll('[data-has-winner]')
      const panel = winners[winners.length - 1]
      const tab = panel && document.getElementById(panel.getAttribute('aria-labelledby'))
      return tab || this.querySelector('[role="tab"]')
    }

    onClick = event => {
      const tab = event.target.closest('.wd-vis-timeline-record-tab')
      if (!tab || !this.contains(tab)) return
      this.activateTab(tab)
    }

    onKeydown = event => {
      const tab = event.target.closest('.wd-vis-timeline-record-tab')
      if (!tab || !this.contains(tab) || !['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return
      const tabs = [...tab.parentElement.querySelectorAll('.wd-vis-timeline-record-tab')]
      const index = tabs.indexOf(tab)
      const next =
        event.key === 'Home'
          ? tabs[0]
          : event.key === 'End'
            ? tabs[tabs.length - 1]
            : event.key === 'ArrowRight'
              ? tabs[(index + 1) % tabs.length]
              : tabs[(index - 1 + tabs.length) % tabs.length]
      if (!next) return
      event.preventDefault()
      this.activateTab(next)
      next.focus()
    }

    activateTab(tab) {
      if (!tab) return
      const tabs = tab.closest('.wd-vis-timeline-record-tabs')
      if (!tabs) return
      const panelId = tab.getAttribute('aria-controls')
      tabs.querySelectorAll('[role="tab"]').forEach(item => {
        const selected = item === tab
        item.classList.toggle('is-active', selected)
        item.setAttribute('aria-selected', selected ? 'true' : 'false')
      })
      this.querySelectorAll('[role="tabpanel"]').forEach(panel => {
        panel.hidden = panel.id !== panelId
      })
      tab.scrollIntoView({ block: 'nearest', inline: 'nearest' })
    }
  }

  if (!customElements.get('wd-vis-timeline-scroll')) {
    customElements.define('wd-vis-timeline-scroll', WdVisTimelineScroll)
  }

  if (!customElements.get('wd-vis-timeline-records')) {
    customElements.define('wd-vis-timeline-records', WdVisTimelineRecords)
  }

  } catch(e) { console.error(e); }
})();
})();
